export class ModeloImprocedencia {
    "idTipoImprocedencia": number = null;
    "nombre": string = "";
    "detalle": string = "";
    "estatus": boolean;
    "OprDesechamientos": Array<any>;
}